import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/open-mdx.png'
import _imports_1 from '@/assets/logo-nepen.png'


const _hoisted_1 = { class: "align-center bg- flex !h-screen !w-screen items-center justify-center bg-[linear-gradient(33deg,rgba(26,174,232,1)_0%,rgba(109,197,232,1)_50%,rgba(207,240,255,1)_100%)]" }
const _hoisted_2 = { class: "card-container h-fit w-11/12 rounded-xl bg-[rgba(255,255,255,0.5)] p-8 shadow backdrop-blur-md sm:w-10/12 md:w-[420px] md:p-12" }
const _hoisted_3 = { class: "text-sky-900" }
const _hoisted_4 = {
  class: "mb-4",
  style: {"--delay":"0.1s"}
}
const _hoisted_5 = { class: "text-center text-sm font-medium text-sky-800" }
const _hoisted_6 = {
  class: "mb-4 flex flex-col gap-2",
  style: {"--delay":"0.2s"}
}
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_9 = {
  class: "mb-4 flex flex-col gap-2",
  style: {"--delay":"0.3s"}
}
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_12 = {
  class: "mb-4 flex flex-col gap-2",
  style: {"--delay":"0.4s"}
}
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "mt-2 space-y-1" }
const _hoisted_15 = { class: "flex items-center gap-2 text-xs" }
const _hoisted_16 = { class: "text-sm text-gray-600" }
const _hoisted_17 = { class: "flex items-center gap-2 text-xs" }
const _hoisted_18 = { class: "text-sm text-gray-600" }
const _hoisted_19 = { class: "flex items-center gap-2 text-xs" }
const _hoisted_20 = { class: "text-sm text-gray-600" }
const _hoisted_21 = { class: "flex items-center gap-2 text-xs" }
const _hoisted_22 = { class: "text-sm text-gray-600" }
const _hoisted_23 = { class: "flex items-center gap-2 text-xs" }
const _hoisted_24 = { class: "text-sm text-gray-600" }
const _hoisted_25 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_26 = { style: {"--delay":"0.5s"} }
const _hoisted_27 = { class: "mt-8 flex flex-col items-center justify-center gap-4" }

import IconsCheck from '@/components/login/IconsCheck.vue'
import SelectLanguage from '@/components/subcomponents/SelectLanguage.vue'
import * as userService from '@/services/userService'
import { useLanguageStore } from '@/stores/LanguageStore'
import { useChangePasswordValidator } from '@/validators/changePasswordValidator'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Tag from 'primevue/tag'
import { useToast } from 'primevue/usetoast'
import { computed, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'RequiredChangePassword',
  setup(__props) {

const languageStore = useLanguageStore()
const toast = useToast()
const router = useRouter()
const isLoading = ref(false)
const errorMessage = ref('')

const { createForm, createEmptyErrors, validateForm, validatePassword } =
  useChangePasswordValidator()

const form = reactive(createForm())
const errors = reactive(createEmptyErrors())

const passwordValidation = computed(() => validatePassword(form.newPassword))

const handleSubmit = async () => {
  const validation = validateForm(form)
  if (!validation.isValid) {
    Object.assign(errors, validation.errors)
    return
  }

  isLoading.value = true
  errorMessage.value = ''

  try {
    await userService.recoverPassword(form.email, form.expiredPassword, form.newPassword)

    toast.add({
      summary: languageStore.t('auth.requiredChangePassword.messages.successSummary'),
      detail: languageStore.t('auth.requiredChangePassword.messages.successDetail'),
      severity: 'success',
      life: 3000,
    })

    setTimeout(() => {
      router.push('/login')
    }, 1500)
  } catch (error: any) {
    const errorMsg =
      error.response?.data?.detail ||
      languageStore.t('auth.requiredChangePassword.messages.errorDetail')
    errorMessage.value = errorMsg

    toast.add({
      summary: languageStore.t('auth.requiredChangePassword.messages.errorSummary'),
      detail: errorMsg,
      severity: 'error',
      life: 3000,
    })
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mb-4 flex items-center justify-center gap-4" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "logo openmdx",
          class: "h-18 w-auto"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          name: "form-field",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.instructions')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "form-field",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.emailLabel')), 1),
              _createVNode(_unref(InputText), {
                id: "email",
                type: "text",
                placeholder: _unref(languageStore).t('auth.requiredChangePassword.placeholders.email'),
                modelValue: form.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
                class: _normalizeClass([{ 'p-invalid': errors.email }, "w-full"])
              }, null, 8, ["placeholder", "modelValue", "class"]),
              (errors.email)
                ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(errors.email), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "form-field",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.expiredPasswordLabel')), 1),
              _createVNode(_unref(Password), {
                toggleMask: "",
                fluid: "",
                modelValue: form.expiredPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.expiredPassword) = $event)),
                invalid: !!errors.expiredPassword,
                placeholder: 
                _unref(languageStore).t('auth.requiredChangePassword.placeholders.expiredPassword')
              
              }, null, 8, ["modelValue", "invalid", "placeholder"]),
              (errors.expiredPassword)
                ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(errors.expiredPassword), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "form-field",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.newPasswordLabel')), 1),
              _createVNode(_unref(Password), {
                toggleMask: "",
                fluid: "",
                modelValue: form.newPassword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.newPassword) = $event)),
                invalid: !!errors.newPassword,
                placeholder: _unref(languageStore).t('auth.requiredChangePassword.placeholders.newPassword')
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(IconsCheck, {
                        isValid: passwordValidation.value.hasUppercase,
                        size: 16
                      }, null, 8, ["isValid"]),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.validation.uppercase')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(IconsCheck, {
                        isValid: passwordValidation.value.hasLowercase,
                        size: 16
                      }, null, 8, ["isValid"]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.validation.lowercase')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(IconsCheck, {
                        isValid: passwordValidation.value.hasNumber,
                        size: 16
                      }, null, 8, ["isValid"]),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.validation.number')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(IconsCheck, {
                        isValid: passwordValidation.value.hasSpecial,
                        size: 16
                      }, null, 8, ["isValid"]),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.validation.special')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(IconsCheck, {
                        isValid: passwordValidation.value.hasMinLength,
                        size: 16
                      }, null, 8, ["isValid"]),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.validation.minLength')), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "invalid", "placeholder"]),
              (errors.newPassword)
                ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(errors.newPassword), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_Transition, {
        name: "form-field",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_unref(Button), {
              label: _unref(languageStore).t('auth.requiredChangePassword.submitButton'),
              class: "w-full",
              onClick: handleSubmit,
              loading: isLoading.value
            }, null, 8, ["label", "loading"])
          ])
        ]),
        _: 1
      }),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_unref(Tag), {
            key: 0,
            severity: "danger",
            value: errorMessage.value,
            class: "mt-4 w-full"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_1,
          alt: "logo nepen",
          class: "h-8 w-auto"
        }, null, -1)),
        _createVNode(SelectLanguage, { opacity: 0.4 })
      ])
    ])
  ]))
}
}

})